import { Icon, type IconName } from "../icons/Icon";
import { cx } from "../utils/format";

/** `src` is the person's own picture; without one the initials stand in. */
export function Avatar({ initials, src, size, ai, icon, className, title }: { initials?: string; src?: string; size?: "sm" | "lg"; ai?: boolean; icon?: IconName; className?: string; title?: string }) {
  return (
    <span className={cx("ob-avatar", size && `ob-avatar--${size}`, ai && "ob-avatar--ai", className)} title={title}>
      {src ? <img className="ob-avatar__img" src={src} alt="" /> : icon ? <Icon name={icon} size="xs" /> : initials}
    </span>
  );
}
